export default __webpack_public_path__ + "static/media/humburger.6792a61f.svg";